import React from "react";
import styled from "styled-components";
import PulseLoader from "react-spinners/PulseLoader";

const Loading = () => {
  return (
    <ComponentContainer>
      <LoaderContainer>
        <PulseLoader color="#94BAFD" size={10} margin={4} loading={true} speedMultiplier={1} />
      </LoaderContainer>
    </ComponentContainer>
  );
};

const ComponentContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  max-width: 480px;
`;

export default Loading;
